// Number / date formatting for the estimate screens.
// Currency $#,##0.00 · quantities 1 decimal · hours 1 decimal · percentages 0.0%

const currency = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });
const currency0 = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
const oneDp = new Intl.NumberFormat("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const twoDp = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const int = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

const safe = (n) => (Number.isFinite(Number(n)) ? Number(n) : 0);

export const fmtCurrency = (n) => currency.format(safe(n));
export const fmtCurrencyShort = (n) => currency0.format(safe(n));
export const fmtQty = (n) => oneDp.format(safe(n));
export const fmtHrs = (n) => oneDp.format(safe(n));
export const fmtDec2 = (n) => twoDp.format(safe(n));
export const fmtInt = (n) => int.format(safe(n));
export const fmtPct = (n) => `${oneDp.format(safe(n) * 100)}%`;

/** Signed delta for History compare: "+$1,234.00" / "−$12.00". */
export const fmtCurrencyDelta = (n) => `${safe(n) >= 0 ? "+" : "−"}${currency.format(Math.abs(safe(n)))}`;
export const fmtPctDelta = (n) => `${safe(n) >= 0 ? "+" : "−"}${oneDp.format(Math.abs(safe(n)) * 100)}%`;

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "—";

/** "2s ago" / "5m ago" — short form for the workspace header. */
export const fmtAgo = (iso, now = Date.now()) => {
  if (!iso) return "—";
  const s = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
